import { render } from "./SuccessActivate.vue?vue&type=template&id=39e7b68c&scoped=true"
import script from "./SuccessActivate.vue?vue&type=script&lang=js"
export * from "./SuccessActivate.vue?vue&type=script&lang=js"

import "./SuccessActivate.vue?vue&type=style&index=0&id=39e7b68c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e7b68c"]])

export default __exports__